import { ResponsiveBar } from '@nivo/bar';

const domainsData = [
  { month: 'Jan', verified: 80, unverified: 25 },
  { month: 'Feb', verified: 95, unverified: 30 },
  { month: 'Mar', verified: 110, unverified: 20 },
  { month: 'Apr', verified: 105, unverified: 40 },
  { month: 'May', verified: 130, unverified: 35 },
  { month: 'Jun', verified: 150, unverified: 25 }
];

export const DomainsBarChart = () => (
  <div style={{ height: '300px' }}>
    <ResponsiveBar
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: 'Month',
        legendPosition: 'middle',
        legendOffset: 32
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: 'Domain Count',
        legendPosition: 'middle',
        legendOffset: -40
      }}
      axisRight={null}
      axisTop={null}
      borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
      colors={{ scheme: 'spectral' }}
      data={domainsData}
      groupMode="stacked"
      indexBy="month"
      indexScale={{ type: 'band', round: true }}
      keys={['verified', 'unverified']}
      labelSkipHeight={12}
      labelSkipWidth={12}
      labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
      legends={[
        {
          dataFrom: 'keys',
          anchor: 'bottom-right',
          direction: 'column',
          justify: false,
          translateX: 120,
          translateY: 0,
          itemsSpacing: 2,
          itemWidth: 100,
          itemHeight: 20,
          itemDirection: 'left-to-right',
          itemOpacity: 0.85,
          symbolSize: 20,
          effects: [{ on: 'hover', style: { itemOpacity: 1 } }]
        }
      ]}
      margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
      padding={0.3}
      valueScale={{ type: 'linear' }}
    />
  </div>
);
